/** Currency + number formatting helpers. */

let currencySymbol = '$';

export function setCurrency(code: string): void {
  const map: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    BRL: 'R$',
    INR: '₹',
    FUN: '⭐',
  };
  currencySymbol = map[code] ?? '$';
}

/** Format a monetary amount with the active currency symbol. */
export function money(v: number): string {
  const abs = Math.abs(v);
  let s: string;
  if (abs >= 100000) s = (v / 1000).toFixed(1) + 'k';
  else if (abs >= 1000) s = v.toLocaleString('en-US', { maximumFractionDigits: 2 });
  else if (Number.isInteger(v)) s = v.toFixed(2);
  else s = v.toFixed(2);
  return `${currencySymbol}${s}`;
}

/** Compact coin count (no currency symbol). */
export function coins(v: number): string {
  if (v >= 1000) return (v / 1000).toFixed(1) + 'k';
  return Math.round(v).toString();
}

/** "x12.5" style multiplier. */
export function mult(v: number): string {
  if (v >= 100) return `x${Math.round(v)}`;
  if (Number.isInteger(v)) return `x${v}`;
  return `x${v.toFixed(2).replace(/0$/, '')}`;
}

export function stakeLabel(v: number): string {
  return `${currencySymbol}${Number.isInteger(v) ? v : v.toFixed(2).replace(/0$/, '')}`;
}
